export const languages = {
  enUS: 'en-US',
  nl: 'nl',
  fr: 'fr',
  frCA: 'fr-CA',
  de: 'de',
  it: 'it',
  ja: 'ja',
  ko: 'ko',
  pt: 'pt',
  ptBR: 'pt-BR',
  es: 'es',
  esLATAM: 'es-419',
  fi: 'fi',
  el: 'el',
  pl: 'pl',
  sv: 'sv',
  ro: 'ro',
  zhCN: 'zh-CN',
} as const;

export const DEFAULT_LOCALE = languages.enUS;

export const translationResources = Object.fromEntries(
  Object.values(languages).map((lang) => [
    lang,
    {
      translation: require(`./data/${lang}.json`),
    },
  ]),
);
